import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { SignPage } from './pages/SignPage';
import { initMetaPixel, trackViewContent } from './lib/metaPixel';
// Tracks ViewContent on every route change (dedupes internally per path)
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackViewContent(location.pathname);
  }, [location.pathname]);
  return null;
}
export function App() {
  // Initialize Meta Pixel exactly once on app mount
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <BrowserRouter data-id="element-0">
      <RouteTracker data-id="element-1" />
      <div className="min-h-screen w-full bg-cosmic-black" data-id="element-2">
        <Navbar data-id="element-3" />
        <main className="pt-16" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/:signId" element={<SignPage data-id="element-9" />} data-id="element-8" />
          </Routes>
        </main>
        <Footer data-id="element-10" />
      </div>
    </BrowserRouter>;
}